import { ApiRequest, ApiResponse, HttpMethod } from '@axl/accel-framework/api';

export class DeleteTopicRequest extends ApiRequest {
    public method = HttpMethod.DELETE;
    public url: string = `/forum/topic/${this.topicId}`;

    constructor(public topicId: string) {
        super();
    }
}

export class DeleteTopicResponse extends ApiResponse {
    constructor(response: any) {
        super(response);
    }
}